//import React from 'react'
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MarkEmailUnreadOutlinedIcon from '@mui/icons-material/MarkEmailUnreadOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import DoneIcon from '@mui/icons-material/Done';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Link } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../config";
import { uploads } from "../../config";
import AdsPanel from './AdsPanel';

const Doctors = () => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleDiv = () => setIsVisible(!isVisible);

  const [isVisible1, setIsVisible1] = useState(false);
  const toggleDiv1 = () => setIsVisible1(!isVisible1);

  const [doctors, setDoctors] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const [users, setUsers] = useState([]);
  const location = useLocation();
  const [expandedIndex, setExpandedIndex] = useState(null);

  useEffect(() => {
    const category = location.pathname.replace("/", "");

    axios
      .get(
        `${API_URL}/api-get-business-listing.php?category=${category}`
      )
      .then((res) => {
        setUsers(res.data.data || []);
      })
      .catch((err) => console.log(err));
  }, [location.pathname]);

  // ✅ GET FILTER CATOGERY AND TYPE CHECKBOX
  useEffect(() => {
    const category = location.pathname.replace("/", ""); // doctors, photographers

    axios
      .get(
        `${API_URL}/api-all-table-filter.php?category=${category}`
      )
      .then((response) => {
        console.log(response.data);
        setDoctors(response.data.data); // API returns {status, category, data}
      })
      .catch((error) => {
        console.error(error);
      });
  }, [location.pathname]);


  const filteredUsers = users.filter((user) => {
    const matchesCategory =
      selectedCategory === "" ||
      (user.doctor_category &&
        user.doctor_category
          .split(",")
          .map((c) => c.trim())
          .includes(selectedCategory));

    const matchesType =
      selectedType === "" ||
      (user.doctor_type &&
        user.doctor_type
          .split(",")
          .map((t) => t.trim())
          .includes(selectedType));

    return matchesCategory && matchesType;
  });
  return (
    <div>
      <div className='breadcrumb'><Link to="/">Home</Link> &nbsp;:&nbsp; Doctors</div>
      <div className='ibodywrap'>
        <div className='row'>
          <div className='col-md-9'>
            <div className='filter-panel'>
              <div className='filter-tabbox'>
                <div className='filter-tab' onClick={toggleDiv}>Doctor Category <ArrowDropDownIcon /></div>
                <div className={isVisible ? "filter-box" : "filter-box hide"} onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)}>
                  {doctors.map((doctor, index) => (
                    <div key={index}>
                      {doctor.doctor_category.split(",").map((category, catIndex) => {
                        const value = category.trim();

                        return (
                          <label key={catIndex} style={{ display: "block" }}>
                            <input type="checkbox" checked={selectedCategory === value}
                              onChange={() =>
                                setSelectedCategory(
                                  selectedCategory === value ? "" : value
                                )
                              }
                            />
                            &nbsp; {value}
                          </label>
                        );
                      })}
                    </div>
                  ))}
                  <button className="clrformbtn" onClick={() => setSelectedCategory("")}>Clear</button>
                </div>
              </div>
              <div className='filter-tabbox'>
                <div className='filter-tab' onClick={toggleDiv1}>Doctor Type <ArrowDropDownIcon /></div>
                <div className={isVisible1 ? "filter-box" : "filter-box hide"} onMouseEnter={() => setIsVisible1(true)} onMouseLeave={() => setIsVisible1(false)}>
                  {doctors.map((doctor, index) => (
                    <div key={index}>
                      {doctor.doctor_type.split(",").map((category, catIndex) => {
                        const value = category.trim();

                        return (
                          <label key={catIndex} style={{ display: "block" }}>
                            <input type="checkbox" checked={selectedType === value}
                              onChange={() =>
                                setSelectedType(
                                  selectedType === value ? "" : value
                                )
                              }
                            />
                            &nbsp; {value}
                          </label>
                        );
                      })}
                    </div>
                  ))}
                  <button className="clrformbtn" onClick={() => setSelectedType("")}>Clear</button>
                </div>
              </div>
            </div>



            {filteredUsers.length > 0 ? (
              filteredUsers.map((user, index) => {
                const services = user.business_services
                  ? user.business_services.split(",")
                  : [];

                return (
                  <div key={user.id || index} className='business-listing fade-in'>
                    <div className='imgbox'>
                      {user.business_logo && (
                        <img src={`${uploads}/${user.business_logo}`} alt={user.business_fullname} width="100" className='drfullimg' />
                      )}
                      <div className='businesstype' style={{ display: 'none' }}>Allopathic | Physician</div>
                    </div>
                    <div className='detail-box'>
                      <div className='title-box'><Link to={user.page_url}><VerifiedIcon /> {user.business_fullname}</Link></div>
                      <div className='location-box' style={{ margin: '0 auto 10px auto' }}><FmdGoodOutlinedIcon /> {user.business_address}, {user.business_city}, {user.business_district}, {user.business_state} - {user.business_zipcode}</div>
                      <div className='dr-sdetails'>
                        <span className='sp1'>{user.doctor_category}</span>
                        <span className="sp2">{user.doctor_type === "Both" ? "Physician & Surgeon" : user.doctor_type}</span>
                        <span className='sp3'>{user.doctor_degree}</span>
                      </div>
                      <div className='service-box'>
                        {services
                          .slice(0, expandedIndex === index ? services.length : 5)
                          .map((service, i) => (
                            <div key={i} className="services">
                              <DoneIcon /> {service.trim()}
                            </div>
                          ))}

                        {services.length > 5 && (
                          <div
                            className="services-more"
                            onClick={() =>
                              setExpandedIndex(
                                expandedIndex === index ? null : index
                              )
                            }
                            style={{ cursor: "pointer", color: "blue" }}
                          >
                            {expandedIndex === index
                              ? "Show Less"
                              : `+${services.length - 5} more`}
                          </div>
                        )}
                      </div>
                      <div className='btn-box'>
                        <a href={`tel:${user.business_contactno1}`} className="contact-no"><CallRoundedIcon />{user.business_contactno1}</a>
                        <a href={`https://wa.me/${user.business_whatsappno}`} className="whatsapp" target="_blank" rel="noopener noreferrer"><WhatsAppIcon />{user.business_whatsappno}</a>
                        <a href={`mailto:${user.email}`} className="contact-no"><MarkEmailUnreadOutlinedIcon />Send Enquiry</a>
                      </div>
                    </div>
                    <div className='clr'></div>
                  </div>
                );
              })
            ) : (
              <div className='business-listing fade-in'>
                <p style={{ margin: 0, color: "red" }}>No results found.</p>
              </div>
            )}



          </div>
          <div className='col-md-3'>
            <AdsPanel />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Doctors
